<form [formGroup]="form" (ngSubmit)="submit()" class="grid grid-cols-1 xl:grid-cols-3 gap-4">
    <div class="xl:col-span-2 flex flex-col gap-4">
        <fb-section-card [title]="'CONTACT_DETAILS' | translate">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <label class="flex flex-col gap-1.5">
                    <span class="text-sm font-medium text-text">{{ 'FIRST_NAME' | translate }}</span>
                    <input pInputText formControlName="firstName" autocomplete="off" />
                </label>
                <label class="flex flex-col gap-1.5">
                    <span class="text-sm font-medium text-text">{{ 'LAST_NAME' | translate }}</span>
                    <input pInputText formControlName="lastName" autocomplete="off" />
                </label>
                <label class="flex flex-col gap-1.5">
                    <span class="text-sm font-medium text-text">{{ 'EMAIL' | translate }}</span>
                    <input pInputText type="email" formControlName="email" autocomplete="off" [invalid]="invalid('email')" />
                    @if (invalid('email')) {
                        <small class="text-red-500">{{ 'FIELD_INVALID_EMAIL' | translate }}</small>
                    }
                </label>
                <label class="flex flex-col gap-1.5">
                    <span class="text-sm font-medium text-text">{{ 'PHONE' | translate }}</span>
                    <input pInputText type="tel" formControlName="phone" autocomplete="off" />
                </label>
            </div>
        </fb-section-card>

        <fb-section-card [title]="'ADDRESS' | translate">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <label class="flex flex-col gap-1.5 md:col-span-2">
                    <span class="text-sm font-medium text-text">{{ 'ADDRESS' | translate }}</span>
                    <input pInputText formControlName="address1" autocomplete="off" />
                </label>
                <label class="flex flex-col gap-1.5">
                    <span class="text-sm font-medium text-text">{{ 'ZIP_CODE' | translate }}</span>
                    <input pInputText formControlName="zipCode" autocomplete="off" />
                </label>
                <label class="flex flex-col gap-1.5">
                    <span class="text-sm font-medium text-text">{{ 'CITY' | translate }}</span>
                    <input pInputText formControlName="city" autocomplete="off" />
                </label>
                <div class="flex flex-col gap-1.5 md:col-span-2">
                    <span class="text-sm font-medium text-text">{{ 'COUNTRY' | translate }}</span>
                    <p-select
                        formControlName="country"
                        [options]="countries"
                        optionLabel="name"
                        optionValue="code"
                        [filter]="true"
                        [showClear]="true"
                        appendTo="body"
                        [placeholder]="'COUNTRY' | translate"
                        class="w-full" />
                </div>
            </div>
        </fb-section-card>

        <fb-section-card [title]="'COMPANY_DETAILS' | translate">
            <div actions class="flex items-center gap-2">
                <span class="text-sm text-text-muted">{{ 'IS_COMPANY' | translate }}</span>
                <p-toggleswitch formControlName="isCompany" />
            </div>
            @if (isCompany()) {
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <label class="flex flex-col gap-1.5">
                        <span class="text-sm font-medium text-text">{{ 'COMPANY_NAME' | translate }}</span>
                        <input pInputText formControlName="companyName" autocomplete="off" />
                    </label>
                    <label class="flex flex-col gap-1.5">
                        <span class="text-sm font-medium text-text">{{ 'ORG_NUMBER' | translate }}</span>
                        <input pInputText formControlName="orgNo" autocomplete="off" />
                    </label>
                </div>
            } @else {
                <p class="text-sm text-text-muted">{{ 'PRIVATE_CUSTOMER_NOTE' | translate }}</p>
            }
        </fb-section-card>
    </div>

    <div class="flex flex-col gap-4">
        <fb-section-card [title]="'ACCESS_RESTRICTIONS' | translate" [description]="restrictionsNote() ?? ('ACCESS_RESTRICTIONS_DESC' | translate)">
            <div class="flex flex-col divide-y divide-border">
                <label class="flex items-center justify-between gap-4 pb-4 cursor-pointer">
                    <span class="flex flex-col gap-0.5">
                        <span class="text-sm font-medium text-text">{{ 'BLOCK_ONLINE_BOOKINGS' | translate }}</span>
                        <span class="text-xs text-text-muted">{{ 'BLOCK_ONLINE_BOOKINGS_DESC' | translate }}</span>
                    </span>
                    <p-toggleswitch formControlName="blackListed" />
                </label>
                <label class="flex items-center justify-between gap-4 pt-4 cursor-pointer">
                    <span class="flex flex-col gap-0.5">
                        <span class="text-sm font-medium text-text">{{ 'EXCLUDE_CRM' | translate }}</span>
                        <span class="text-xs text-text-muted">{{ 'EXCLUDE_CRM_DESC' | translate }}</span>
                    </span>
                    <p-toggleswitch formControlName="excludeCrm" />
                </label>
            </div>
        </fb-section-card>

        <fb-section-card [title]="'INTERNAL_NOTES' | translate" [description]="'INTERNAL_NOTES_DESC' | translate">
            <textarea pTextarea formControlName="notes" rows="7" class="w-full"></textarea>
        </fb-section-card>
    </div>

    <fb-save-bar [visible]="dirty()" [saving]="saving()" [canSave]="canSave()" (save)="submit()" (discard)="discard()" />
</form>
